<template>
    <ion-page class="ion-page" id="main">
        <default-header>
            <template v-slot:start>
                <ion-buttons slot="start">
                    <header-menu/>
                </ion-buttons>
            </template>
        </default-header>

        <ion-content fullscreen>
            <flash-messages/>

            <ion-card id="covid-agreement-form"
                      class="floating">
                <ion-card-header>
                    <ion-card-title style="text-align: center;">
                        {{ $t('ncrypt.covid_triage_agreement.title') }}
                    </ion-card-title>

                    <ion-card-subtitle>
                        <img
                            :src="`${ $store.getters.api_url }/company-logo`"
                            @error="$event.target.src = `${ $store.getters.webservice_url }/storage/logo.png`"
                            style="height: 60px; width: auto; margin: 0 auto;" alt=""/>
                    </ion-card-subtitle>
                </ion-card-header>

                <ion-card-content>
                    <h2 style="text-align: center;">
                        {{ $t('ncrypt.covid_triage_agreement.content_title') }}
                    </h2>

                    <ul>
                        <li>
                            {{ $t('ncrypt.covid_triage_agreement.list_one.one') }}
                        </li>
                        <li>
                            {{ $t('ncrypt.covid_triage_agreement.list_one.two') }}
                        </li>
                    </ul>

                    <ul>
                        <li>
                            {{ $t('ncrypt.covid_triage_agreement.list_two.one') }}
                        </li>
                        <li>
                            {{ $t('ncrypt.covid_triage_agreement.list_two.two') }}
                        </li>
                        <li>
                            {{ $t('ncrypt.covid_triage_agreement.list_two.three') }}
                        </li>
                    </ul>

                    <div style="text-align: center;">
                        <div v-if="completed">
                            {{ $t('ncrypt.covid_triage_agreement.completed') }}
                        </div>
                        <ion-button v-else @click="sign()">
                            {{ $t('ncrypt.covid_triage_agreement.sign_button') }}
                        </ion-button>
                    </div>
                </ion-card-content>
            </ion-card>
        </ion-content>
    </ion-page>
</template>

<script>
    import DefaultHeader from "../../components/nav/DefaultHeader";
    import FlashMessages from "../../components/ui-elements/FlashMessages";
    import HeaderMenu from "../../components/nav/HeaderMenu";
    import {ApiError} from "@/errors/ApiError";

    export default {
        components: {
            HeaderMenu,
            FlashMessages,
            DefaultHeader,
        },
        data() {
            return {
                completed: this.$store.getters.user.covid_agreement_signed_at !== null,
            }
        },
        methods: {
            sign() {
                this.$http.post('/covid-passport/covid-agreement-form')
                    .then(async response => {
                        if (response.status >= 300) {
                            new ApiError(response);
                            return;
                        }

                        await this.$store.dispatch('refreshUser');

                        this.completed = true;
                    })
                    .catch(reason => new ApiError(reason));
            },
        },
    }
</script>
